<template>
  <div class="bg-white">
    <!-- Mobile filter dialog -->
    <TransitionRoot as="template" :show="open">
      <Dialog as="div" class="fixed inset-0 flex z-40 sm:hidden" @close="open = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0"
                         enter-to="opacity-100" leave="transition-opacity ease-linear duration-300"
                         leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-black bg-opacity-25"/>
        </TransitionChild>

        <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
                         enter-from="translate-x-full" enter-to="translate-x-0"
                         leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
                         leave-to="translate-x-full">
          <div
              class="ml-auto relative max-w-xs w-full h-full bg-white shadow-xl py-4 pb-12 flex flex-col overflow-y-auto">
            <div class="px-4 flex items-center justify-between">
              <h2 class="text-lg font-medium text-gray-900">Фильтры</h2>
              <button type="button"
                      class="-mr-2 w-10 h-10 bg-white p-2 rounded-md flex items-center justify-center text-gray-400"
                      @click="open = false">
                <XIcon class="h-6 w-6" aria-hidden="true"/>
              </button>
            </div>

            <!-- Filters -->
            <form class="mt-4">
              <Disclosure as="div" v-for="(filter, filterIdx) in filters" :key="filter.id"
                          class="border-t border-gray-200 px-4 py-6" v-slot="{ open }">
                <h3 class="-mx-2 -my-3 flow-root">
                  <DisclosureButton
                      class="px-2 py-3 bg-white w-full flex items-center justify-between text-sm text-gray-400">
                    <span class="font-medium text-gray-900">
                      {{ filter.name }}
                    </span>
                    <span class="ml-6 flex items-center">
                      <ChevronDownIcon :class="[open ? '-rotate-180' : 'rotate-0', 'h-5 w-5 transform']"
                                       aria-hidden="true"/>
                    </span>
                  </DisclosureButton>
                </h3>
                <DisclosurePanel class="pt-6">
                  <div class="space-y-6">
                    <div v-for="(filterOption, filterOptionIdx) in filter.options" :key="filterOption.id"
                         class="flex items-center">
                      <input :id="`filter-mobile-${filter.id}-${filterOptionIdx}`" :name="`${filter.id}[]`"
                             :value="filterOption" v-model="selected[filterIdx].options" type="checkbox"
                             :checked="filterOption.checked"
                             class="h-4 w-4 border-gray-300 rounded text-primary-600 focus:ring-primary-500"/>
                      <label :for="`filter-mobile-${filter.id}-${filterOptionIdx}`" class="ml-3 text-sm text-gray-500">
                        {{ filterOption.name }}
                      </label>
                    </div>
                  </div>
                </DisclosurePanel>
              </Disclosure>
            </form>
          </div>
        </TransitionChild>
      </Dialog>
    </TransitionRoot>

    <!-- Filters -->
    <section aria-labelledby="filter-heading">
      <div class="relative z-10 bg-white border-b border-gray-200 pb-4">
        <div class="mx-auto  flex items-center justify-between">

          <!-- сортировка -->
          <div class="text-left">
            <Menu as="div" class="relative inline-block " v-if="false">
              <div>
                <MenuButton
                    class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                  Сортировка
                  <ChevronDownIcon class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                   aria-hidden="true"/>
                </MenuButton>
              </div>

              <transition enter-active-class="transition ease-out duration-100"
                          enter-from-class="transform opacity-0 scale-95"
                          enter-to-class="transform opacity-100 scale-100"
                          leave-active-class="transition ease-in duration-75"
                          leave-from-class="transform opacity-100 scale-100"
                          leave-to-class="transform opacity-0 scale-95">
                <MenuItems
                    class="origin-top-left absolute left-0 mt-2 w-40 rounded-md shadow-2xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div class="py-1">
                    <MenuItem v-for="option in sortOptions" :key="option.name" v-slot="{ active }">
                      <a :href="option.href"
                         :class="[option.current ? 'font-medium text-gray-900' : 'text-gray-500', active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm']">
                        {{ option.name }}
                      </a>
                    </MenuItem>
                  </div>
                </MenuItems>
              </transition>
            </Menu>
          </div>


          <button type="button" class="inline-block text-sm font-medium text-gray-700 hover:text-gray-900 sm:hidden"
                  @click="open = true">Фильтры
          </button>

          <div class="flex items-center">
            <div class="hidden sm:inline-block">
              <div class="flow-root">
                <PopoverGroup class="-mx-4 flex items-center divide-x divide-gray-200">
                  <Popover v-for="(filter, filterIdx) in filters" :key="filter.name"
                           class="px-4 relative inline-block text-left">
                    <PopoverButton
                        class="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                      <span>{{ filter.name }}</span>
<!--                      <span v-if="filterIdx === 0"
                            class="ml-1.5 rounded py-0.5 px-1.5 bg-gray-200 text-xs font-semibold text-gray-700 tabular-nums">{{
                          filter.options.length
                        }}</span>-->
                      <ChevronDownIcon class="flex-shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                       aria-hidden="true"/>
                    </PopoverButton>

                    <transition enter-active-class="transition ease-out duration-100"
                                enter-from-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-from-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95">
                      <PopoverPanel
                          class="origin-top-right absolute right-0 mt-2 bg-white rounded-md shadow-2xl p-4 ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <form class="space-y-4">
                          <div v-for="(option, optionIdx) in filter.options" :key="option.id"
                               class="flex items-center">
                            <input :id="`filter-${filter.id}-${optionIdx}`" :name="`${filter.id}[]`"
                                   :value="option" type="checkbox" v-model="selected[filterIdx].options"
                                   class="h-4 w-4 border-gray-300 rounded text-primary-600 focus:ring-primary-500"
                            />
                            <label :for="`filter-${filter.id}-${optionIdx}`"
                                   class="ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap">
                              {{ option.name }}
                            </label>
                          </div>
                        </form>
                      </PopoverPanel>
                    </transition>
                  </Popover>
                </PopoverGroup>

              </div>

            </div>
            <div class="inline-block ml-4" v-if="search">
              <div class="flex rounded-md shadow-sm">
                <div class="relative flex-grow focus-within:z-10">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true"/>
                  </div>
                  <input type="text" v-model="searchValue"
                         class="focus:ring-primary-500 focus:border-primary-500 block w-full rounded-none rounded-l-md pl-10 sm:hidden border-gray-300"
                         placeholder="Поиск"/>
                  <input type="text" v-model="searchValue"
                         class="hidden focus:ring-primary-500 focus:border-primary-500 w-full rounded-none rounded-l-md pl-10 sm:block sm:text-sm border-gray-300"
                         placeholder="Поиск"/>
                </div>
                <button type="button" @click="sendSearch"
                        class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Active filters -->
      <div class="bg-gray-50">
        <div class="space-x-4 mx-auto py-3 sm:flex sm:items-center px-1 border-b" v-show="activeFilters.length > 0">
          <template v-for="activeFilter in activeFilters" :key="activeFilter.id">
            <span class="text-xs font-semibold uppercase tracking-wide text-gray-500">{{ activeFilter.name }}</span>
            <div aria-hidden="true" class="hidden w-px h-5 bg-gray-300 sm:block sm:ml-4"/>
            <div class="mt-2 sm:mt-0 sm:ml-4">
              <div class="-m-1 flex flex-wrap items-center">
              <span v-for="(option, indexOption) in activeFilter.options" :key="option.id"
                    class="m-1 inline-flex rounded-full border border-gray-200 items-center py-1.5 pl-3 pr-2 text-sm font-medium bg-white text-gray-900">
                <span>{{ option.name }}</span>
                <button type="button" @click="removeFilter(activeFilter, indexOption)"
                        class="flex-shrink-0 ml-1 h-4 w-4 p-1 rounded-full inline-flex text-gray-400 hover:bg-gray-200 hover:text-gray-500">
                  <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                    <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7"/>
                  </svg>
                </button>
              </span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {computed, ref, watch} from 'vue'
import {
  Dialog,
  DialogOverlay,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {ChevronDownIcon, SearchIcon, SortAscendingIcon} from '@heroicons/vue/solid'

const sortOptions = [
  {name: 'Most Popular', href: '#', current: true},
  {name: 'Best Rating', href: '#', current: false},
  {name: 'Newest', href: '#', current: false},
]

export default {

  components: {
    Dialog,
    DialogOverlay,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    TransitionChild,
    TransitionRoot,
    ChevronDownIcon,
    XIcon,
    // eslint-disable-next-line vue/no-unused-components
    SearchIcon, SortAscendingIcon,
  },
  emits: ['update:modelValue', 'update:queryStr'],
  props: {
    filters: {
      required: true,
    },
    modelValue: {},
    search: {
      default: false,
    }
  },
  setup(props, {emit}) {
    const open = ref(false)
    const selected = ref([])
    const searchValue = ref('')

    props.filters.forEach(item => {
      selected.value.push({id: item.id, name: item.name, array_query: item.array_query ?? false, options: []})
    })

    if (props.search)
      selected.value.push({id: 'search', name: 'Поиск', array: false, options: []})

    const activeFilters = computed(() => selected.value.filter(item => item.options.length > 0))
    const filtersStr = computed(() => {

      let str = ''
      selected.value.forEach(item => {
        let paramStr = ''

        item.options.forEach(option => {

          paramStr = (paramStr ? paramStr + '&' : '') + item.id + (item.array_query ? '[]=' : '=') + option.id
        })

        if (str && paramStr) str += '&'
        str += paramStr
      })

      //if (str) str = '?' + str
      return str;
    })

    watch(selected.value, () => {
      emit('update:modelValue', activeFilters.value)
      emit('update:queryStr', filtersStr.value)
    })

    return {
      sortOptions,
      open,
      selected,
      activeFilters,
      searchValue,
      filtersStr
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    removeFilter(activeFilter, valueIndex) {
      this.selected.forEach((item, index) => {
        if (item.id === activeFilter.id) {
          this.selected[index].options.splice(valueIndex, 1)
          if (activeFilter.id === 'search')
            this.searchValue = ''
        }
      })

      /*      console.log(filterIndex, valueIndex)
            console.log(this.selected[filterIndex])
            console.log(this.selected)
            if (this.selected[filterIndex].key === 'search')
              this.searchValue = ''*/

      // ;
    },
    sendSearch() {
      if (this.search) {
        if (this.searchValue) {
          this.selected[this.selected.length - 1].options = [{
            id: this.searchValue,
            name: this.searchValue
          }]
        } else {
          this.selected[this.selected.length - 1].options = []
        }
      }

      /*     let str = this.filtersStr;
           if (str) str += "&search=" + this.searchValue
           else str = "?search=" + this.searchValue

           this.$emit('update:queryStr', str)*/
    }
  }
}
</script>